"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Brand = void 0;
var zod_1 = require("zod");
var Brand;
(function (Brand) {
    Brand.Schema = zod_1.z.enum(["eljouren", "rorjouren", "ipis"]);
})(Brand || (Brand = {}));
exports.Brand = Brand;
